(function () {
  function getCalculatedDate() {
    var textElem = document.getElementById('variant-production-time-text');
    if (textElem) {
      var match = (textElem.textContent || '').match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
      if (match) {
        return match[1].padStart(2,'0') + '.' + match[2].padStart(2,'0') + '.' + match[3];
      }
    }
    return ''; 
  }

  function injectHandoverDate() {
    // PROBO / PRINTMONDO SCHUTZ: Bricht ab, wenn die externe App aktiv ist
    if (document.querySelector('#root') || document.querySelector('.probo-app-container') || document.querySelector('probo-ui')) {
      return; 
    }

    var date = getCalculatedDate();
    if (!date) return; 

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      // MIT UNTERSTRICH: Übergibt die Daten unsichtbar an den Checkout
      var input = form.querySelector('input[name="properties[_Versandübergabe]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_Versandübergabe]';
        form.appendChild(input);
      }
      input.value = date;
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(injectHandoverDate, 300); 
  });

  var observer = new MutationObserver(function() {
    clearTimeout(window.__handoverTimer);
    window.__handoverTimer = setTimeout(injectHandoverDate, 200);
  });
  
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();